import type { TemplateOnlyComponent as TOC } from '@ember/component/template-only';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';
import { or } from 'ember-truth-helpers';
import type { HotelDetailsFormModel } from 'lumen/routes/hotel/settings/my-property/hotel-details';

import CardAddress from './card-address';
import CardBusinessProfile from './card-business-profile';

interface SettingsMyHotelFormHotelDetailsSignature {
  Args: {
    model: HotelDetailsFormModel;
  };
}

const SettingsMyHotelFormHotelDetails = <template>
  <div>
    {{#if
      (or
        @model.requestProfileTask.isRunning
        @model.geocodeProfileCoordsTask.isRunning
      )
    }}
      <PrismLoadingBar />
    {{/if}}
    <div class="flex flex-col gap-600" data-test-id="form-hotel-details">
      <CardBusinessProfile
        @isLoading={{@model.requestProfileTask.isRunning}}
        @onPendingLogoChange={{@model.onPendingLogoChange}}
        @pendingLogoChange={{@model.pendingLogoChange}}
        @profile={{@model.requestProfileTask.last.value}}
      />
      <CardAddress
        @isGeocoding={{@model.geocodeProfileCoordsTask.isRunning}}
        @isLoading={{@model.requestProfileTask.isRunning}}
        @profile={{@model.requestProfileTask.last.value}}
      />
    </div>
  </div>
</template> satisfies TOC<SettingsMyHotelFormHotelDetailsSignature>;

export default SettingsMyHotelFormHotelDetails;
